import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { PlatformDetector } from '../../platformDetector/platformDetector.component';

/**
 * Conditionally renders (or not) the _children_ elements depending on the props provided and current platform
 **/
export class PlatformConditional extends PureComponent {
  static propTypes = {
    hideOnMobile: PropTypes.bool,
    hideOnTablet: PropTypes.bool,
    hideOnTabletLarge: PropTypes.bool,
    hideOnDesktop: PropTypes.bool,
    hideOnDesktopLarge: PropTypes.bool,
    children: PropTypes.any,
  };

  static defaultProps = {
    hideOnMobile: false,
    hideOnTablet: false,
    hideOnTabletLarge: false,
    hideOnDesktop: false,
    hideOnDesktopLarge: false,
  };

  render() {
    const { hideOnDesktop, hideOnMobile, hideOnTablet, hideOnTabletLarge, hideOnDesktopLarge } = this.props;

    return (
      <PlatformDetector>
        {({ isMobile, isTabletPortrait, isTabletLandscape, isDesktop, isDesktopFull }) => {
          if (
            (isMobile && hideOnMobile) ||
            (isTabletPortrait && hideOnTablet) ||
            (isTabletLandscape && hideOnTabletLarge) ||
            (isDesktop && hideOnDesktop) ||
            (isDesktopFull && hideOnDesktopLarge)
          ) {
            return null;
          }

          return this.props.children;
        }}
      </PlatformDetector>
    );
  }
}
